// ── src/routes/application-routes/home.routes.jsx ──

import Artwork from "@/pages/artwork";
import CrossAppAuthBridge from "@/pages/auth/cross-app-bridge";
import HomeArtists from "@/pages/home/artists";
import HomeArtlists from "@/pages/home/artlists";
import HomeArtworks from "@/pages/home/artworks";
import AuctionCollectionPage from "@/pages/home/auction";
import HomeCommunity from "@/pages/home/community";
import HomeDiscover from "@/pages/home/discover";
import HomeGalleries from "@/pages/home/galleries";
import HomeLimitedEditionsPage from "@/pages/home/limited-editions";
import SuarteWorld from "@/pages/home/suarteworld";
import CollectionPage from "@/shared-components/home/collection-page";

const HomeRoutes = [
  { path: "/", element: <HomeDiscover /> },
  { path: "/login", element: <HomeDiscover showAuthPopup={true} authPopUpPage={"login"} /> },
  { path: "/sign-up", element: <HomeDiscover showAuthPopup={true} authPopUpPage={"sign-up"} /> },
  { path: "/auth/bridge", element: <CrossAppAuthBridge /> },
  { path: "/galleries", element: <HomeGalleries /> },
  { path: "/artists", element: <HomeArtists /> },
  { path: "/artworks", element: <HomeArtworks /> },
  { path: "/artlists", element: <HomeArtlists /> },
  { path: "/artwork/:slug", element: <Artwork /> },
  { path: "/community", element: <HomeCommunity/> },
  { path: "/suarteworld", element: <SuarteWorld /> },
  { path: "/suarteworld/artwork/:slug", element: <Artwork /> },
  { path: "/auction/:eventSlug", element: <AuctionCollectionPage /> },

  // Tu ruta anterior para “otras” internal collections:
  { path: "/collections/:collection_id", element: <CollectionPage /> },
  { path: "/limited-editions", element: <HomeLimitedEditionsPage /> },

  // ─── NUEVA RUTA “COLLECTION POR SLUG DE SUBCATEGORÍA” ───
  {
    path: "/category/:search_type/:search_item",
    element: <CollectionPage />
  }
];

export default HomeRoutes;
